import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';

import { DataUpdatedOnComponent } from './components/data-updated-on/data-updated-on.component';

@NgModule({
  declarations: [DataUpdatedOnComponent],
  imports: [CommonModule, NgbTooltipModule],
  exports: [DataUpdatedOnComponent],
})
export class DataUpdatedOnModule {}
